import { API_BASE_URL } from "../urls.api";

export const getAlarmsByRoomIdUrl = (roomId: string) => `${API_BASE_URL}/alarms/${roomId}`;

export const getAlarmsByRoomIdAndRangeUrl = (roomId: string, from: number, to: number) =>
  `${API_BASE_URL}/alarms/${roomId}/range?from=${from}&to=${to}`;
